// extracted by mini-css-extract-plugin
module.exports = {"tipBox":"style_tipBox__342Hx","tipBoxIcon":"style_tipBoxIcon__1YDQG","tipBoxContent":"style_tipBoxContent__2dTD4"};